import { Component } from '@angular/core';
/* eslint-disable @angular-eslint/component-selector */
@Component({
  selector: 'mode-embed-root',
  template: '',
})
export class AppComponent {
  constructor() {}
}
